export default "__VITE_PUBLIC_ASSET__6eff54c1__"